import { FC, ReactNode, useMemo } from 'react';
import { useConfirm } from './ConfirmationService';
import { Modal, ModalAction } from '@/components/shared/modal/Modal';
import { strings } from '../translation/strings';

interface Props {
  children: ReactNode;
}

export const ConfirmCheck: FC<Props> = ({ children }) => {
  const { proceedCallback, confirmationMessage, requested, clear, action, confirmButtonLabel } = useConfirm(state => ({
    proceedCallback: state.onProceedCallback,
    confirmationMessage: state.confirmationMessage,
    confirmButtonLabel: state.confirmButtonLabel,
    requested: state.confirmationRequested,
    clear: state.clearRequest,
    action: state.action
  }));

  const modalActions = useMemo(() => {
    if (!proceedCallback) {
      return [];
    }

    const actions: ModalAction[] = [
      {
        label: confirmButtonLabel,
        callback: proceedCallback
      }
    ];

    if (action) {
      actions.push({
        label: action.label,
        callback: () => {
          action.callback();
          proceedCallback();
        },
        primary: true
      });
    }
    return actions;
  }, [proceedCallback, action, confirmButtonLabel]);

  return (
    <>
      {children}
      {proceedCallback && confirmationMessage && (
        <Modal customActions={modalActions} onClose={clear} open={requested} header={strings.common.confirm}>
          {confirmationMessage}
        </Modal>
      )}
    </>
  );
};
